import { IList } from '@pnp/sp/presets/all';
import {
    SharePointService,
    UpdateService,
    FieldType,
} from 'sp-office365-framework';

export class UpdateToVersion1115Component {
    constructor(
        private _sharePointService: SharePointService,
        private _updateService: UpdateService
    ) {}

    run() {
        const promise = new Promise<void>(async (resolve, reject) => {
            const projectList: IList =
                await this._sharePointService.web.lists.getByTitle('Aufträge');

            const promises = [
                await this._updateService.addField(
                    projectList,
                    'OW_Nummer',
                    FieldType.Text
                ),
            ];

            Promise.all(promises)
                .then(() => resolve())
                .catch((error) => reject(error));
        });
        return promise;
    }
}
